// extracted by mini-css-extract-plugin
module.exports = {"listOfItems":"_3p6PqoUokTt0_GGb1_TteE","item":"_4Fz58nx0prZBHUCJsIh2A","dot":"_2MqAcA5wswvieqjmO92rax"};